/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppGetYoutubeIntegrationStatsSelfViewersQueryResponse, WebAppGetYoutubeIntegrationStatsSelfViewersPathParams, WebAppGetYoutubeIntegrationStatsSelfViewersQueryParams, WebAppGetYoutubeIntegrationStatsSelfViewers401, WebAppGetYoutubeIntegrationStatsSelfViewers403 } from "../models/WebAppGetYoutubeIntegrationStatsSelfViewers";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { webAppGetYoutubeIntegrationStatsSelfViewers } from "../axios/webAppGetYoutubeIntegrationStatsSelfViewers";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const webAppGetYoutubeIntegrationStatsSelfViewersQueryKey = (station: WebAppGetYoutubeIntegrationStatsSelfViewersPathParams["station"], params: WebAppGetYoutubeIntegrationStatsSelfViewersQueryParams) => ["api-v2", { url: '/web-app/v1/youtube-stats/viewers/:station/self', params: {station:station} }, ...(params ? [params] : [])] as const

export type WebAppGetYoutubeIntegrationStatsSelfViewersQueryKey = ReturnType<typeof webAppGetYoutubeIntegrationStatsSelfViewersQueryKey>

export function webAppGetYoutubeIntegrationStatsSelfViewersQueryOptions(station: WebAppGetYoutubeIntegrationStatsSelfViewersPathParams["station"], params: WebAppGetYoutubeIntegrationStatsSelfViewersQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = webAppGetYoutubeIntegrationStatsSelfViewersQueryKey(station, params)
        return queryOptions<WebAppGetYoutubeIntegrationStatsSelfViewersQueryResponse, ResponseErrorConfig<WebAppGetYoutubeIntegrationStatsSelfViewers401 | WebAppGetYoutubeIntegrationStatsSelfViewers403>, WebAppGetYoutubeIntegrationStatsSelfViewersQueryResponse, typeof queryKey>({
         enabled: !!(station&& params),
         queryKey,
         queryFn: async ({ signal }) => {
            return webAppGetYoutubeIntegrationStatsSelfViewers(station, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Uses the station `youtubeChannelId`. Responds with 400 when it is not set, and 404 when the channel is not in the live-viewers catalog.
 * @summary Viewer time series for the station YouTube channel
 * {@link /web-app/v1/youtube-stats/viewers/:station/self}
 */
export function useWebAppGetYoutubeIntegrationStatsSelfViewers<TData = WebAppGetYoutubeIntegrationStatsSelfViewersQueryResponse, TQueryData = WebAppGetYoutubeIntegrationStatsSelfViewersQueryResponse, TQueryKey extends QueryKey = WebAppGetYoutubeIntegrationStatsSelfViewersQueryKey>(station: WebAppGetYoutubeIntegrationStatsSelfViewersPathParams["station"], params: WebAppGetYoutubeIntegrationStatsSelfViewersQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<WebAppGetYoutubeIntegrationStatsSelfViewersQueryResponse, ResponseErrorConfig<WebAppGetYoutubeIntegrationStatsSelfViewers401 | WebAppGetYoutubeIntegrationStatsSelfViewers403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? webAppGetYoutubeIntegrationStatsSelfViewersQueryKey(station, params)
         

         const query = useQuery({
          ...webAppGetYoutubeIntegrationStatsSelfViewersQueryOptions(station, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<WebAppGetYoutubeIntegrationStatsSelfViewers401 | WebAppGetYoutubeIntegrationStatsSelfViewers403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}